import { doc, setDoc, increment } from 'firebase/firestore';
import { db } from '../firebase/config';

export const trackVisit = async () => {
  if (typeof window === 'undefined') return;
  
  // Skip tracking for admin panel visits
  if (window.location.pathname.startsWith('/admin')) return;

  // Prevent double counting within the same tab session
  const sessionKey = 'nidsoft_session_visited';
  if (sessionStorage.getItem(sessionKey)) return;
  sessionStorage.setItem(sessionKey, 'true');

  // Check for unique visitor status using localStorage
  const uniqueKey = 'nidsoft_unique_visited';
  const isNewUnique = !localStorage.getItem(uniqueKey);
  if (isNewUnique) {
    localStorage.setItem(uniqueKey, 'true');
  }

  try {
    const today = new Date().toLocaleDateString('en-CA'); // Outputs: YYYY-MM-DD
    const docRef = doc(db, 'analytics', 'visits');
    
    const updateData = {
      total: increment(1),
      [`history.${today}`]: increment(1)
    };

    if (isNewUnique) {
      updateData.unique = increment(1);
    }

    await setDoc(docRef, updateData, { merge: true });
  } catch (error) {
    console.warn("Analytics tracking error:", error);
  }
};
